<template>
    <div id="resourceForm" class="con-exemple-prompt">
        <vs-row>
            <vs-col vs-w="12">
                 <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Type* :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <multiselect
                            v-model="resource.type"
                            name="addCampaignType"
                            :options="campaignTypes"
                            track-by="id"
                            label="name"
                            :multiple="false"
                            :group-select="false"
                            placeholder="Recherche ..."
                            select-label=""
                            select-group-label=""
                            selected-label=""
                            deselect-label=""
                            deselect-group-label=""
                        />
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Libellé* :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input
                            v-model="resource.title"
                            name="addCampaignTitle"
                            class="w-full"
                            placeholder="Libellé"
                            required
                        />
                    </div>
                </div>

                <vs-divider position="left" class="mt-20 font-bold"><p class="bold">Destinataires(s)</p></vs-divider>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Service(s)* :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <Multiselect
                            v-model="resource.services"
                            name="addCampaignServices"
                            :options="groupedServicesByEstablishments"
                            :multiple="true"
                            group-values="services"
                            group-label="establishment"
                            :group-select="true"
                            placeholder="Recherche ..."
                            track-by="id"
                            label="title"
                            select-label=""
                            select-group-label="L'établissement"
                            selected-label=""
                            deselect-label=""
                            deselect-group-label=""
                        >
                            <span slot="noResult">Aucun résultat.</span>
                        </Multiselect>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Ajouter des destinataires :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <Multiselect
                            v-model="resource.users"
                            name="addCampaignUsers"
                            :options="groupedUsersByServices"
                            :multiple="true"
                            group-values="users"
                            group-label="service"
                            :group-select="true"
                            placeholder="Recherche ..."
                            track-by="id"
                            label="full_name"
                            select-label=""
                            select-group-label="Le service"
                            selected-label=""
                            deselect-label=""
                            deselect-group-label=""
                        >
                            <span slot="noResult">Aucun résultat.</span>
                        </Multiselect>
                    </div>
                </div>

                <vs-divider position="left" class="mt-20 font-bold"><p class="bold">Etape(s) validation</p></vs-divider>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Service(s) du contributeur :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <Multiselect
                            v-model="resource.contribution_services"
                            name="addCampaignContributeurServices"
                            :options="groupedServicesByEstablishments"
                            :multiple="true"
                            group-values="services"
                            group-label="establishment"
                            :group-select="true"
                            placeholder="Recherche ..."
                            track-by="id"
                            label="title"
                            select-label=""
                            select-group-label="L'établissement"
                            selected-label=""
                            deselect-label=""
                            deselect-group-label=""
                        >
                            <span slot="noResult">Aucun résultat.</span>
                        </Multiselect>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Service(s) du valideur :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <Multiselect
                            v-model="resource.validation_services"
                            name="addCampaignValideurServices"
                            :options="groupedServicesByEstablishments"
                            :multiple="true"
                            group-values="services"
                            group-label="establishment"
                            :group-select="true"
                            placeholder="Recherche ..."
                            track-by="id"
                            label="title"
                            select-label=""
                            select-group-label="L'établissement"
                            selected-label=""
                            deselect-label=""
                            deselect-group-label=""
                        >
                            <span slot="noResult">Aucun résultat.</span>
                        </Multiselect>
                    </div>
                </div>

                <vs-divider position="left" class="mt-20 font-bold"><p class="bold">Contenu</p></vs-divider>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Bloc(s) de questions* :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <multiselect
                            v-model="resource.blocs"
                            name="addCampaignBlocs"
                            :options="blocs"
                            track-by="id"
                            label="title"
                            :multiple="true"
                            :group-select="false"
                            placeholder="Recherche ..."
                            select-label=""
                            select-group-label=""
                            selected-label=""
                            deselect-label=""
                            deselect-group-label=""
                        />
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Questionnaire :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <multiselect
                            v-model="resource.rating_questionnaire"
                            name="addCampaignRatingQuestionnaire"
                            :options="rating_questionnaires"
                            track-by="id"
                            label="name"
                            :multiple="false"
                            :group-select="false"
                            placeholder="Recherche ..."
                            select-label=""
                            select-group-label=""
                            selected-label=""
                            deselect-label=""
                            deselect-group-label=""
                        />
                    </div>
                </div>

                <vs-divider position="left" class="mt-20 font-bold"><p class="bold">Synthèse</p></vs-divider>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Questions d'analyse :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <multiselect
                            v-model="resource.campaign_questionnaire"
                            name="addCampaignQuestionnaire"
                            :options="campaign_questionnaires"
                            track-by="id"
                            label="name"
                            :multiple="false"
                            :group-select="false"
                            placeholder="Recherche ..."
                            select-label=""
                            select-group-label=""
                            selected-label=""
                            deselect-label=""
                            deselect-group-label=""
                        />
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Champs de synthèse :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <multiselect
                            v-model="resource.campaign_field"
                            name="addCampaignField"
                            :options="campaign_fields"
                            track-by="id"
                            label="name"
                            :multiple="false"
                            :group-select="false"
                            placeholder="Recherche ..."
                            select-label=""
                            select-group-label=""
                            selected-label=""
                            deselect-label=""
                            deselect-group-label=""
                        />
                    </div>
                </div>

                <vs-divider position="left" class="mt-20 font-bold"><p class="bold">Séquence</p></vs-divider>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Période* :</span>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                        <vs-input
                            v-model="resource.start_date"
                            type="date"
                            name="addCampaignStartDate"
                            label="Début*"
                            class="w-full"
                        />
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                        <vs-input
                            v-model="resource.end_date"
                            type="date"
                            name="addCampaignEndDate"
                            label="Fin*"
                            class="w-full"
                        />
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Date 1er envoi :</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input
                            v-model="resource.sent_date_1"
                            type="date"
                            name="addCampaignDate1"
                            class="w-full"
                            label="Date"
                        />
                    </div>
                    <div class="vx-col sm:w-1/6 w-full">
                        <vs-input
                            v-model="resource.sent_hour_1"
                            type="number"
                            min="0"
                            max="23"
                            name="addCampaignHour1"
                            class="w-full"
                            label="Heure"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Date 2eme envoi :</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input
                            v-model="resource.sent_date_2"
                            type="date"
                            name="addCampaignDate2"
                            class="w-full"
                            label="Date"
                        />
                    </div>
                    <div class="vx-col sm:w-1/6 w-full">
                        <vs-input
                            v-model="resource.sent_hour_2"
                            type="number"
                            min="0"
                            max="23"
                            name="addCampaignHour2"
                            class="w-full"
                            label="Heure"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Date 3eme envoi :</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input
                            v-model="resource.sent_date_3"
                            type="date"
                            name="addCampaignDate2"
                            class="w-full"
                            label="Date"
                        />
                    </div>
                    <div class="vx-col sm:w-1/6 w-full">
                        <vs-input
                            v-model="resource.sent_hour_3"
                            type="number"
                            min="0"
                            max="23"
                            name="addCampaignHour3"
                            class="w-full"
                            label="Heure"
                        />
                    </div>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import TypeForm from "@components/form/TypeForm";

export default {
    name: 'CatalogForm',
    components: {
        Multiselect, TypeForm
    },
    props: {
        value: {
            required: false,
            type: Object
        }
    },
    data () {
        return {
            resource: {},
            campaignTypes: [],
            campaignTypesLoading: true,
            users: [],
            usersLoading: true,
            rating_questionnaires: [],
            rating_questionnairesLoading: true,
            campaign_questionnaires: [],
            campaign_questionnairesLoading: true,
            campaign_fields: [],
            campaign_fieldsLoading: true,
            establishments: [],
            establishmentsLoading: true,
            blocs: [],
            blocsLoading: true,
        }
    },
    watch: {
        value (newValue, oldValue) {
            if (newValue === oldValue) return
            this.initResource()
        },
        'resource': {
            handler () {
                this.value.type                         = this.resource.type;
                this.value.title                        = this.resource.title;
                this.value.rating_questionnaire         = this.resource.rating_questionnaire;
                this.value.campaign_questionnaire       = this.resource.campaign_questionnaire;
                this.value.campaign_field               = this.resource.campaign_field;

                this.value.services                     = this.resource.services;
                this.value.users                        = this.resource.users;
                this.value.start_date                   = this.resource.start_date;
                this.value.end_date                     = this.resource.end_date;
                this.value.sent_date_1                  = this.resource.sent_date_1;
                this.value.sent_date_2                  = this.resource.sent_date_2;
                this.value.sent_date_3                  = this.resource.sent_date_3;

                this.value.sent_hour_1                  = this.resource.sent_hour_1;
                this.value.sent_hour_2                  = this.resource.sent_hour_2;
                this.value.sent_hour_3                  = this.resource.sent_hour_3;

                this.value.contribution_services        = this.resource.contribution_services;
                this.value.validation_services          = this.resource.validation_services;
                this.value.blocs                        = this.resource.blocs;

                this.$emit('input', this.value)
                console.log('Resource changed: ', this.value)
            }, deep: true
        },
        hasError (value) {
            this.$emit('error', value)
        }
    },
    computed: {
        hasError() {
            let error = !this.resource.title
                || !this.resource.type?.id
                || !this.resource.services?.length
                || !this.resource.rating_questionnaire?.id
                || !this.resource.campaign_questionnaire?.id
                || !this.resource.campaign_field?.id
                || !this.resource.start_date
                || !this.resource.end_date
                || !this.resource.blocs?.length
            return error;
        },

        groupedServicesByEstablishments() {
            let toShow = [];
            this.establishments.forEach(e => {
                toShow.push({
                    establishment: e.name,
                    services: this.services
                        ? this.services.filter(service => service.establishment_id === e.id)
                        : []
                });
            });

            return toShow;
        },
        groupedUsersByServices() {
            let toShow = [];

            this.services.forEach(s => {
                toShow.push({
                    service: s.title,
                    users: this.users
                        ? this.users.filter(user => user.services.map(us => us.id).includes(s.id))
                        : []
                })
            })

            return toShow;
        }
    },
    methods: {
        async loadUsers() {
            return window.axios({
                method: 'get',
                url: '/api/referentiel/users',
                params: {perpage: 9999, include: ['services']},
            })
            .then(response => {
                this.users = response.data.data;
                this.usersLoading = false;
            })
            .catch((err) => {
                console.log(err)
                this.notifyError(err, `Une erreur est survenue`)
            })
        },
        async loadBlocOpenQuestions() {
            return window.axios({
                method: 'get',
                url: '/api/referentiel/rating-questionnaires',
                params: {perpage: 9999, include: []},
            })
                .then(response => {
                    this.rating_questionnaires = response.data;
                    this.rating_questionnairesLoading = false;
                })
                .catch((err) => {
                    console.log(err)
                    this.notifyError(err, `Une erreur est survenue`)
                })
        },
        async loadSynthesisQuestions() {
            return window.axios({
                method: 'get',
                url: '/api/referentiel/campaign-questionnaires',
                params: {perpage: 9999, include: []},
            })
                .then(response => {
                    this.campaign_questionnaires = response.data;
                    this.campaign_questionnairesLoading = false;
                })
                .catch((err) => {
                    console.log(err)
                    this.notifyError(err, `Une erreur est survenue`)
                })
        },
        async loadSynthesisFields() {
            return window.axios({
                method: 'get',
                url: '/api/referentiel/campaign-fields',
                params: {perpage: 9999, include: []},
            })
                .then(response => {
                    this.campaign_fields = response.data;
                    this.campaign_fieldsLoading = false;
                })
                .catch((err) => {
                    console.log(err)
                    this.notifyError(err, `Une erreur est survenue`)
                })
        },
        async loadBlocs() {
            return window.axios({
                method: 'get',
                url: '/api/referentiel/blocs',
                params: {perpage: 9999, include: []},
            })
                .then(response => {
                    this.blocs = response.data.data;
                    this.blocsLoading = false;
                })
                .catch((err) => {
                    console.log(err)
                    this.notifyError(err, `Une erreur est survenue`)
                })
        },
        async loadCampaignTypes() {
            return window
                .axios({
                    method: "get",
                    url: "/api/gestion/campaigns/types",
                    params: { perpage: 100 }
                })
                .then(response => {
                    this.campaignTypes = response.data
                    this.campaignTypesLoading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },
        async loadEstablishment() {
            return window
                .axios({
                    method: "get",
                    url: "/api/referentiel/establishments",
                    params: {
                        perpage: 9999,
                    }
                })
                .then(response => {
                    this.establishments = response.data.data;
                    this.establishmentsLoading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        initResource() {
            this.resource = {
                type: this.value.type,
                title: this.value.title,
                rating_questionnaire: this.value.rating_questionnaire,
                campaign_questionnaire: this.value.campaign_questionnaire || (this.campaign_questionnaires.length ? this.campaign_questionnaires[0] : []),
                campaign_field: this.value.campaign_field || (this.campaign_fields.length ? this.campaign_fields[0] : []),
                services: this.value.services,
                users: this.value.users,
                start_date : this.value.start_date,
                end_date : this.value.end_date,
                sent_date_1 : this.value.sent_date_1,
                sent_hour_1: this.value.sent_hour_1,
                sent_date_2 : this.value.sent_date_2,
                sent_hour_2: this.value.sent_hour_2,
                sent_date_3 : this.value.sent_date_3,
                sent_hour_3: this.value.sent_hour_3,
                contribution_services: this.value.contribution_services,
                validation_services: this.value.validation_services,
                blocs: this.value.blocs,
            }
        },

    },
    async created() {
        this.initResource();

        this.$vs.loading();
        await Promise.all([
            this.loadUsers(),
            this.loadBlocOpenQuestions(),
            this.loadSynthesisQuestions(),
            this.loadSynthesisFields(),
            this.loadBlocs(),
            this.loadCampaignTypes(),
            this.loadEstablishment()
        ]);
        this.$vs.loading.close();
    }
}
</script>

<style lang="scss" scoped>
#resourceForm {
    display: block;
    > div {
        padding: 1rem;
    }

    ::v-deep input {
        min-height: 43px;
        padding: 1rem 1.3rem;
        font-size:1.1rem;
    }
    .multiselect {
        min-height: 43px;
        &.multiselect--disabled {
            border-radius: 5px;
            ::v-deep .multiselect__select {
                border-radius: 0 4px 4px 0;
                height: 41px;
            }
        }
    }
}
</style>
